import { ABP, eLayoutType } from '@abp/ng.core';

export const API_STATUS_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/api-status',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:ApiStatuses',
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.ApiStatuses',
    breadcrumbText: '::ApiStatuses',
    invisible: true
  },
];
